import {
    CHARGE_ADD_STARTED,
    CHARGE_ADD_FINISHED,
    CHARGE_ADD_FAILED,
    CHARGE_UPDATE_STARTED,
    CHARGE_UPDATE_FINISHED,
    CHARGE_UPDATE_FAILED,
    CHARGE_UPDATE_CANCELLED,
    CHARGE_REMOVE_STARTED,
    CHARGE_REMOVE_FINISHED,
    CHARGE_REMOVE_FAILED,
    CHARGE_QUANTITY_SET,
    CHARGE_COMMENT_SET,
    SUBMIT_UNNECESSARY_TRUCK_ROLL_STARTED,
    SUBMIT_UNNECESSARY_TRUCK_ROLL_FINISHED,
    SUBMIT_UNNECESSARY_TRUCK_ROLL_FAILED

} from 'constants/actionTypes';

export const chargeAddStarted = (request, orderId) => ({type: CHARGE_ADD_STARTED, request, orderId});
export const chargeAddFinished = (payload, orderId) => ({type: CHARGE_ADD_FINISHED, payload, orderId});
export const chargeAddFailed = (payload, orderId) => ({type: CHARGE_ADD_FAILED, payload, orderId});

export const chargeUpdateStarted = (request, orderId) => ({type: CHARGE_UPDATE_STARTED, request, orderId});
export const chargeUpdateFinished = (payload, orderId) => ({type: CHARGE_UPDATE_FINISHED, payload, orderId});
export const chargeUpdateFailed = (payload, orderId) => ({type: CHARGE_UPDATE_FAILED, payload, orderId});
export const chargeUpdateCancelled = (request, orderId) => ({type: CHARGE_UPDATE_CANCELLED, request, orderId});

export const chargeRemoveStarted = (request, orderId) => ({type: CHARGE_REMOVE_STARTED, request, orderId});
export const chargeRemoveFinished = (payload, orderId) => ({type: CHARGE_REMOVE_FINISHED, payload, orderId});
export const chargeRemoveFailed = (payload, orderId) => ({type: CHARGE_REMOVE_FAILED, payload, orderId});

export const chargeQuantitySet = (chargeId, quantity, orderId) => ({type: CHARGE_QUANTITY_SET, chargeId, quantity, orderId});
export const chargeCommentSet = (chargeId, comment, orderId) => ({type: CHARGE_COMMENT_SET, chargeId, comment, orderId});

export const submitUnnecessaryTruckRollStarted = (request, orderId) => ({type: SUBMIT_UNNECESSARY_TRUCK_ROLL_STARTED, request, orderId});
export const submitUnnecessaryTruckRollFinished = (payload, orderId) => ({type: SUBMIT_UNNECESSARY_TRUCK_ROLL_FINISHED, payload, orderId});
export const submitUnnecessaryTruckRollFailed = (payload, orderId) => ({type: SUBMIT_UNNECESSARY_TRUCK_ROLL_FAILED, payload, orderId});


// WEBPACK FOOTER //
// ./src/actions/chargeActions.js